module.exports = __webpack_public_path__ + "static/media/SushiContainer.d20f81fb.png";